import React from "react";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { handleDuplicateCamera } from "./SiteAboutPageUtils/handleDuplicateCamera";
import { useNavigate } from "react-router-dom";
import {
  AlertState,
  SiteCameras,
} from "./SiteAboutPageUtils/siteAboutInterfaces";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const DuplicateCameraSiteButton = ({
  selected,
  setSiteCameras,
  setAlertState,
  setSelected,
  setSyncNeeded,
}: {
  selected: readonly string[];
  setSiteCameras: Dispatcher<SiteCameras>;
  setAlertState: Dispatcher<AlertState>;
  setSelected: Dispatcher<readonly string[]>;
  setSyncNeeded: Dispatcher<boolean>;
}) => {
  const text = (
    <>
      <ContentCopyIcon fontSize="small" />
      &nbsp;DUPLICATE CAMERA
    </>
  );
  const submittedObject = {
    camera_ids: selected,
  };
  const navigate = useNavigate();
  return (
    <OrangeTextButton
      disabled={!selected[0]}
      onClick={() => {
        handleDuplicateCamera(
          submittedObject,
          navigate,
          setSiteCameras,
          setAlertState,
          setSelected,
          setSyncNeeded
        );
      }}
      text={text}
    />
  );
};
